<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
             Department of Agri Product Sale and Marketing/ ຟອມລາຍຈ່າຍ
            
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid==6 || roleid==7">
        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂລາຍຈ່າຍ" v-if="adddataform && !isopentime">
         <div class="columns" >
            <div class="column">
              <h3 class="title">ເພິ່ມ/ ແກ້ໄຂລາຍຈ່າຍ</h3>
            </div>
          </div>
          <div class="columns" >
            <div class="column">
              <div class="columns">
               
                <div class="column">
                  <b-field label="ປະເພດລາຍຈ່າຍ">
                    <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedPaymentType"
                    label="NAME"
                    track-by="ID"
                    :options="paymentTypeList"
                  >
                  </Multiselect>
                  </b-field>
                </div>
                
                <div class="column">
                  <b-field label="ຈຳນວນເງິນ">
                    <b-input v-model.trim="total" type="number"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ລາຍລະອຽດ">
                    <b-input
                      maxlength="500"
                      v-model.trim="detail"
                      type="textarea"
                      placeholder="ລາຍລະອຽດ"
                    ></b-input>
                  </b-field>
                </div>
              </div>
             
              <b-field label="" style="float: right">
                <b-field v-if="saveAction">
                  <button class="button is-info" @click="saveForm">
                    ບັນທຶກ
                  </button>
                </b-field>
                <b-field v-if="updateAction">
                  <div class="columns">
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-primary"
                          @click="updateMarket"
                        >
                          ແກ້ໄຂ
                        </button>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-info"
                          @click="openSaveMarketForm"
                        >
                          ຟອມເພີ່ມຕະຫຼາດ
                        </button>
                      </b-field>
                    </div>
                  </div>
                </b-field>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ເວລາເປີດ ຕະຫຼາດ"  v-if="isopentime"> 
          <div class="columns" >
            <div class="column">
              <h3 class="title">ເວລາເປີດ-ປິດ {{ selectedMarketName }}</h3>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="columns">
                <b-field label="ວັນທີ">
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="selecteddate"
                      >
                      </b-datepicker>
                    </b-field>
              </div>
              <br>
              <div class="columns">
                <b-field label="ເວລາເປີດ">
                  <Multiselect
                    placeholder="ເລືອກເວລາເປີດ"
                    v-model.trim="selectedopentime"
                    label="TIME"
                    track-by="TIME"
                    :options="timeList"
                  >
                  </Multiselect>
                </b-field>
              </div>
              <br>
              <div class="columns">
                <b-field label="ເວລາປິດ">
                  <Multiselect
                    placeholder="ເລືອກເວລາປິດ"
                    v-model.trim="selectedclosetime"
                    label="TIME"
                    track-by="TIME"
                    :options="timeList"
                  >
                  </Multiselect>
                </b-field>
              </div>
              <div class="columns">
                <b-field>
                <button
                  class="button is-info"
                  @click="saveMarketTime"
                >
                  ບັນທຶກ
                </button>
                      </b-field>
              </div>
              
            </div>
            <div class="column">
                <b-field label="ຕາຕະລາງເປີດ-ປິດຕະຫຼາດ">
                  <table 
                    class="table is-fullwidth "
                  >
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="45%">
                          ວັນທີ
                        </th>
                        <th class="has-text-left " width="25%">
                          ເວລາເປີດ
                        </th>
                        <th class="has-text-left " width="25%">
                          ເວລາປິດ
                        </th>                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in marketopenclosetime"
                        :key="data.ID"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>
                          {{ dateFormatter(data.MARKETDATE) }}
                        </td>
                        <td>
                          {{ data.OPENTIME }}
                        </td>
                        <td>
                          {{ data.CLOSETIME }}
                        </td>
                        
                        
                      </tr>
                    </tbody>
                  </table>
                </b-field>
            </div>
          </div>

        </b-tab-item>

        <b-tab-item label="ໃບສະເໜີ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ໃບສະເໜີ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ປະເພດລາຍຈ່າຍ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຈຳນວນເງິນ
                      </th>
                      <th class="has-text-left " width="15%">
                        ວັນທີສະເໜີ
                      </th>
                      <th class="has-text-left " width="30%">
                        ລາຍລະອຽດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ສະຖານະ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activemarkets"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        <b-field v-if="data.PAYMENTTYPE==2">
                          ລາຍຈ່າຍຊື້ອຸປະກອນ
                        </b-field>
                        <b-field v-if="data.PAYMENTTYPE==3">
                          ລາຍຈ່າາຍບໍລິຫານ
                        </b-field>
                        <b-field v-if="data.PAYMENTTYPE==10">
                          ລາຍຈ່າຍອື່ນໆ
                        </b-field>
                      </td>
                      <td>
                        {{ data.TOTAL }}
                      </td>
                      <td>
                        {{dateFormatter(data.REQUESTDATE) }}
                      </td>
                      <td>
                        {{ data.DETAIL }}
                      </td>
                     
                      <td class="has-text-centered">
                        <b-field v-if="data.STATUS==0">
                          ລໍຖ້າອະນຸມັດ
                        </b-field>
                        <b-field v-else-if="data.STATUS==1">
                          ອະນຸມັດແລ້ວ
                        </b-field>
                        <b-field v-else-if="data.STATUS==-1">
                          ຖືກປະຕິເສດ
                        </b-field>
                           
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  data() {
    return {
    roleid: null,
    userName: null,
    selectedCountry: null,
    countryList: [],
    isProvinceSelected: false,
    selectedProvince: null,
    provinceList:  [],
    userBranchid: null,
 
    

    activemarkets: [],
    inactivemarkets: [],
    marketid: null,
    oldmarketname: null,
    marketname: null,
    countryid: null,
    provinceid: null,
    oldprovinceid: null,
    district: null,
    olddistrict: null,
    village: null,
    oldvillage: null,


    activeTab: 1,
    saveAction: true,
    updateAction: false,
    adddataform: true,
    updatedataform: false,
    
    branchUsername: null,
    userProvince: null,
    isopentime: false,
    selectedMartketID: null,
    selectedMarketName: null,
    marketopenclosetime: [],
    selecteddate: null,
    selectedopentime: null,
    selectedclosetime: null,
    

    paymentTypeList: [{"ID":"2", "NAME":"ລາຍຈ່າຍອຸປະກອນ"},
                     {"ID":"3", "NAME":"ລາຍຈ່າຍບໍລິຫານ"},
                     {"ID":"10", "NAME":"ລາຍຈ່າຍອື່ນໆ"}
              ],
    selectedPaymentType: null,
    total: null,
    detail: null,
  };
  },
  methods: {
    getProvince(){
      RestAPI.getProvincebyCountry(1)
        .then(res => {
          // console.log("country ..." + res.data)
          this.provinceList = res.data;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    saveForm() {
      if (this.selectedPaymentType === null || this.total === null ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          branchid: this.userBranchid,
          total: this.total,
          detail: this.detail,
          type: this.selectedPaymentType.ID,
          username: this.username
        };
        // console.log("pa:" + JSON.stringify(params))
        RestAPI.saveDasmPaymentForm(params)
          .then(() => {
            this.$swal("ບັນທຶກ ສຳເລັດ!", "", "success");
            
            this.activeTab = 2;
            this.saveAction = true;
            this.updateAction = false;
            this.selectedPaymentType = null;
            this.total = null;
            this.detail = null;
            this.getPaymentRequest();
            this.activeTab = 1;
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getPaymentRequest() {
      RestAPI.getDASMPaymentRequest(this.userBranchid)
        .then(res => {
          console.log("list:"+ JSON.stringify(res.data))
          console.log("userBranchid:" + this.userBranchid)
          this.activemarkets = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    updateForm(ID, MARKETNAME, PROVINCEID, PROVINCENAME, DISTRICT, VILLAGE) {
     
      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.isopentime = false;
      this.marketid = ID;
      this.oldmarketname =MARKETNAME;
      this.marketname = MARKETNAME;
      this.district = DISTRICT;
      this.village = VILLAGE;
      this.selectedProvince ={"ID": PROVINCEID,"NAME": PROVINCENAME};
      this.selectedMarketName = MARKETNAME;
      
    },
    openSaveMarketForm() {
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.isopentime = false;
      this.marketname = null;
      this.selectedProvince = null;
      this.district = null;
      this.village = null;
      this.selectedMarketName = null;
    },
    updateMarket() {
      console.log("this.marketname: "  +this.marketname)
      console.log("this.district: "  +this.district)
      if (this.marketname.length ==0 || this.selectedProvince.length ==0 || this.district.length ==0  || this.village.length ==0) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else if(this.roleid == 7 && this.selectedProvince.ID != this.userProvince){ 
         this.$swal("ກະລຸນາເລືຶອກແຂວງ ທີ່ຂຶ້ນກັບຕົນເອງ", "", "error");
      }else {
        var params = {
        oldmarketname : this.oldbranchname,
        marketid: this.marketid,
        marketname: this.marketname,
        provinceid : this.selectedProvince.ID,
        district : this.district,
        village : this.village,
        username: this.username
      };

      // console.log("pa: " + JSON.stringify(params))
     
      RestAPI.updateMarket(params)
        .then(res => {
          // console.log("data: "+ JSON.stringify(res.data))
          if (res.data == "duplicate marketname") {
            this.$swal(
              "ຊື່ຕະຫຼາດຊ້ຳ",
              "-",
              "error"
            );
            return false;
          }

          this.$swal("ອັບເດດຕະຫຼາດ ສຳເລັດ!", "", "success");

          this.activeTab = 1;
          this.saveAction = true;
          this.updateAction = false;
          this.marketname = null;
          this.selectedProvince = null;
          this.district = null;
          this.village = null;
          this.getPaymentRequest();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
      }
      
    },
    changeSataus(id,status){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            table: "market",
            id: id,
            status: status,
            username: this.username
          };
          RestAPI.changeSataus(params)
            .then(() => {
            
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getPaymentRequest();

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },
    
    opentimeForm(data) {
     this.isopentime = true;
     this.activeTab = 0;
     this.selectedMartketID = data.ID;
     this.selectedMarketName = data.MARKETNAME;
     this.getMarketOpenCloseTime(data.ID);
      
    }, 

    getMarketOpenCloseTime(marketid){
      RestAPI.getMarketOpenCloseTime(marketid)
          .then(res => {
            console.log("getMarketOpenCloseTime:"+ JSON.stringify(res.data))
            this.marketopenclosetime = res.data;
          })
          .catch(error => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      
      
    },

   saveMarketTime(){
    // console.log("this.selecteddate: " + this.dateFormatterYYYYMMDD(this.selecteddate))
    // console.log("this.selectedopentime: " + this.selectedopentime.TIME)
      if (this.selecteddate === null || this.selectedopentime === null || this.selectedclosetime === null ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          marketid: this.selectedMartketID,
          marketdate: this.dateFormatterYYYYMMDD(this.selecteddate),
          opentime: this.selectedopentime.TIME,
          closetime: this.selectedclosetime.TIME,
          username: this.username
        };
        console.log("f: ", JSON.stringify(params))
        RestAPI.saveMarketTime(params)
          .then(() => {
  
            this.$swal("ເພີ່ມເວລາ ສຳເລັດ!", "", "success");
            
            this.selecteddate = null;
            this.selectedopentime = null;
            this.selectedclosetime = null;
            this.getMarketOpenCloseTime(this.selectedMartketID);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
   },

    print() {
      window.print();
    },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvince = this.user.BSMPROVINCEID;
    this.userBranchid = this.user.DASMBRANCHID;
    this.branchUsername = this.user.ROLEID == 6 ? 'ALL' : this.user.USERNAME,
    this.getPaymentRequest();
    this.getProvince();
    this.selecteddate = new Date();
    // console.log("this.user: "+ JSON.stringify(this.user));
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
